import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pv-pv-recruitment-registration',
  templateUrl: './pv-recruitment-registration.component.html',
  styleUrls: ['./pv-recruitment-registration.component.scss']
})
export class PvRecruitmentRegistrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

}
